module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPBAMAAADJ+Ih5AAAAJ1BMVEUAP40AP40AP40AP40AP40AP40AP40AP40AP40AP40AP40AP40AP414WUSGAAAADXRSTlMBUcHLhmwm2rANMxefWwjP1QAAAIJJREFUCNdjYOByMjbyYgCCDBNBEaUFDAxsNqsZuHOsGBhmdANFuQ9tYBDfwJDFwLA5gKGFgcGFgYFVgaEKzGAzYChjYIhIS+BWADHClU5zGzCoMjBMFJRkNGAIBhnKwOTAsN0BxAhPYGAsmcDAMLUUyBFqXZbaHABkTDyspHxwAgMALpYZSLKte68AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shijianlan.png
// module id = jydJ
// module chunks = 1